import {
    CREATE_DESPATCH_DC_DETAILS_FAILURE,
    CREATE_DESPATCH_DC_DETAILS_REQUEST,
    CREATE_DESPATCH_DC_DETAILS_SUCCESS,
    CREATE_USER_FORM_DESPATCH_DC_DETAILS,
    DELETE_DESPATCH_DC_DETAILS_FAILURE,
    DELETE_DESPATCH_DC_DETAILS_REQUEST,
    DELETE_DESPATCH_DC_DETAILS_SUCCESS,
    FETCH_SINGLE_DESPATCH_DC_DETAILS_FAILURE,
    FETCH_SINGLE_DESPATCH_DC_DETAILS_REQUEST,
    FETCH_SINGLE_DESPATCH_DC_DETAILS_SUCCESS,
    FETCH_DESPATCH_DC_DETAILS_FAILURE,
    FETCH_DESPATCH_DC_DETAILS_REQUEST,
    FETCH_DESPATCH_DC_DETAILS_SUCCESS,
    DESPATCH_DC_DETAILS_USERFORM_RESET,
    UPDATE_DESPATCH_DC_DETAILS_FAILURE,
    UPDATE_DESPATCH_DC_DETAILS_REQUEST,
    UPDATE_DESPATCH_DC_DETAILS_SUCCESS,
    FETCH_DESPATCH_DC_DETAILS_BY_ID_REQUEST,
    FETCH_DESPATCH_DC_DETAILS_BY_ID_SUCCESS,
    FETCH_DESPATCH_DC_PREVIOUS_LIST_REQUEST,
    FETCH_DESPATCH_DC_PREVIOUS_LIST_SUCCESS,
    FETCH_DESPATCH_DC_PREVIOUS_LIST_FAILURE,
    CREATE_USER_FORM_DESPATCH_DC_EDIT_QTY,
    RESET_DESPATCH_DC_EDIT_QTY_V2,
    RESET_DESPATCH_DC_SECOND_GRIG_EDIT_QTY_V2,
    CREATE_USER_FORM_DESPATCH_DC_SECOND_GRID_EDIT_QTY,
    FETCH_DESPATCH_DC_DETAILS_FIRST_GRID_REQUEST,
    FETCH_DESPATCH_DC_DETAILS_FIRST_GRID_SUCCESS,
    FETCH_DESPATCH_DC_DETAILS_FIRST_GRID_FAILURE,
    FETCH_DESPATCH_DC_DETAILS_SECOND_GRID_FAILURE,
    FETCH_DESPATCH_DC_DETAILS_SECOND_GRID_SUCCESS,
    FETCH_DESPATCH_DC_DETAILS_SECOND_GRID_REQUEST,
    CREATE_DESPATCH_DC_DETAILS2_REQUEST,
    CREATE_DESPATCH_DC_DETAILS2_SUCCESS,
    CREATE_DESPATCH_DC_DETAILS2_FAILURE,
    CREATE_USER_FORM_DESPATCH_DC_GENERATE_QTY
} from './despatchDCDetails.actionsType';

// dd
export const DESPATCH_DC_DETAILS = 'despatchDCDetails';

let initialState = {
    loading: false,
    despatchDCDetailsById: [],
    despatchDCDetails: [],
    previousList: [],
    editDespatchQtyList: [],
    editDespatchSecondGridQtyList: [],
    grnNoByYarnPO: [],
    // userform: {
    //     fldRate: 0,
    //     fldId: [],
    //     fldQuantity: 0,
    //     fldGrossValue: 0,
    //     fldDiscountValue: 0,
    //     fldIGSTValue: 0,
    //     fldSGSTValue: 0,
    //     fldCGSTValue: 0,
    //     fldTaxableValue: 0,
    //     fldGSTValue: 0,
    //     fldSGSTPercentage: 0,
    //     fldCGSTPercentage: 0,
    //     fldIGSTPercentage: 0,
    //     fldFKBagWeight: 0,
    //     fldFKNoofBags: 0,
    //     fldPOQuantity: 0,
    //     fldInwardQuantity: 0,
    //     fldDiscountPercentage: 0,
    //     InwardNO: []
    // },
    userform: {},
    selectedDespatchDCDetails: {},
    errorMessage: '',
    iperrorMessage: ''
};

export let despatchDCDetailsReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;
    switch (type) {
        case FETCH_DESPATCH_DC_DETAILS_REQUEST:
        case FETCH_DESPATCH_DC_DETAILS_FIRST_GRID_REQUEST:
        case FETCH_DESPATCH_DC_DETAILS_SECOND_GRID_REQUEST:
        case FETCH_DESPATCH_DC_PREVIOUS_LIST_REQUEST:
        case FETCH_DESPATCH_DC_DETAILS_BY_ID_REQUEST:
        case CREATE_DESPATCH_DC_DETAILS_REQUEST:
        case CREATE_DESPATCH_DC_DETAILS2_REQUEST:
        case FETCH_SINGLE_DESPATCH_DC_DETAILS_REQUEST:
        case UPDATE_DESPATCH_DC_DETAILS_REQUEST:
        case DELETE_DESPATCH_DC_DETAILS_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_DESPATCH_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                despatchDCDetails: updatePayload
            };
        case FETCH_DESPATCH_DC_DETAILS_FIRST_GRID_SUCCESS:
            return {
                ...state,
                loading: false,
                editDespatchSecondGridQtyList: updatePayload?.CUD
            };
        case FETCH_DESPATCH_DC_PREVIOUS_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                previousList: updatePayload?.Program
            };
        case FETCH_DESPATCH_DC_DETAILS_SECOND_GRID_SUCCESS:
            return {
                ...state,
                loading: false,
                editDespatchSecondGridQtyList: updatePayload?.STDDN && updatePayload?.STDDN.map((x) => ({ ...x, isCheck: false }))
            };
        case FETCH_DESPATCH_DC_DETAILS_BY_ID_SUCCESS:
            return {
                ...state,
                loading: false,
                despatchDCDetailsById: updatePayload
            };

        case CREATE_DESPATCH_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                // userform: {
                //     fldRate: 0,
                //     fldId: [],
                //     fldQuantity: 0,
                //     fldGrossValue: 0,
                //     fldDiscountValue: 0,
                //     fldIGSTValue: 0,
                //     fldSGSTValue: 0,
                //     fldCGSTValue: 0,
                //     fldTaxableValue: 0,
                //     fldGSTValue: 0,
                //     fldSGSTPercentage: 0,
                //     fldCGSTPercentage: 0,
                //     fldIGSTPercentage: 0,
                //     fldFKBagWeight: 0,
                //     fldFKNoofBags: 0,
                //     fldPOQuantity: 0,
                //     fldInwardQuantity: 0,
                //     fldDiscountPercentage: 0,
                //     InwardNO: []
                // },
                editDespatchSecondGridQtyList: updatePayload?.STD
            };
        case CREATE_DESPATCH_DC_DETAILS2_SUCCESS:
            return {
                ...state,
                loading: false,
                // userform: {
                //     fldRate: 0,
                //     fldId: [],
                //     fldQuantity: 0,
                //     fldGrossValue: 0,
                //     fldDiscountValue: 0,
                //     fldIGSTValue: 0,
                //     fldSGSTValue: 0,
                //     fldCGSTValue: 0,
                //     fldTaxableValue: 0,
                //     fldGSTValue: 0,
                //     fldSGSTPercentage: 0,
                //     fldCGSTPercentage: 0,
                //     fldIGSTPercentage: 0,
                //     fldFKBagWeight: 0,
                //     fldFKNoofBags: 0,
                //     fldPOQuantity: 0,
                //     fldInwardQuantity: 0,
                //     fldDiscountPercentage: 0,
                //     InwardNO: []
                // },
                userform: updatePayload,
                editDespatchSecondGridQtyList: []
            };
        case FETCH_SINGLE_DESPATCH_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: updatePayload
            };
        case UPDATE_DESPATCH_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                selectedDespatchDCDetails: {},
                userform: {
                    fldRate: 0,
                    fldId: [],
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKBagWeight: 0,
                    fldFKNoofBags: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0,
                    fldDiscountPercentage: 0,
                    InwardNO: []
                }
            };
        case DELETE_DESPATCH_DC_DETAILS_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {
                    fldRate: 0,
                    fldId: [],
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKBagWeight: 0,
                    fldFKNoofBags: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0,
                    fldDiscountPercentage: 0,
                    InwardNO: []
                },
                selectedDespatchDCDetails: {}
            };
        case CREATE_USER_FORM_DESPATCH_DC_GENERATE_QTY:
            return {
                ...state,
                loading: false,
                editDespatchSecondGridQtyList: payload
            }

        case FETCH_DESPATCH_DC_DETAILS_FAILURE:
        case FETCH_DESPATCH_DC_PREVIOUS_LIST_FAILURE:
        case FETCH_DESPATCH_DC_DETAILS_FIRST_GRID_FAILURE:
        case FETCH_DESPATCH_DC_DETAILS_SECOND_GRID_FAILURE:
        case FETCH_SINGLE_DESPATCH_DC_DETAILS_FAILURE:
        case CREATE_DESPATCH_DC_DETAILS_FAILURE:
        case CREATE_DESPATCH_DC_DETAILS2_FAILURE:
        case UPDATE_DESPATCH_DC_DETAILS_FAILURE:
        case DELETE_DESPATCH_DC_DETAILS_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: updatePayload
            };
        case CREATE_USER_FORM_DESPATCH_DC_DETAILS:
            return {
                ...state,
                loading: false,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case CREATE_USER_FORM_DESPATCH_DC_EDIT_QTY:
            return {
                ...state,
                loading: false,
                editDespatchQtyList: payload
            };
        case CREATE_USER_FORM_DESPATCH_DC_SECOND_GRID_EDIT_QTY:
            return {
                ...state,
                loading: false,
                editDespatchSecondGridQtyList: payload
            };
        case RESET_DESPATCH_DC_EDIT_QTY_V2:
            return {
                ...state,
                loading: false,
                editDespatchQtyList: []
            };
        case RESET_DESPATCH_DC_SECOND_GRIG_EDIT_QTY_V2:
            return {
                ...state,
                loading: false,
                editDespatchSecondGridQtyList: []
            };
        case DESPATCH_DC_DETAILS_USERFORM_RESET:
            return {
                ...state,
                userform: {
                    fldRate: 0,
                    fldId: [],
                    fldQuantity: 0,
                    fldGrossValue: 0,
                    fldDiscountValue: 0,
                    fldIGSTValue: 0,
                    fldSGSTValue: 0,
                    fldCGSTValue: 0,
                    fldTaxableValue: 0,
                    fldGSTValue: 0,
                    fldSGSTPercentage: 0,
                    fldCGSTPercentage: 0,
                    fldIGSTPercentage: 0,
                    fldFKBagWeight: 0,
                    fldFKNoofBags: 0,
                    fldPOQuantity: 0,
                    fldInwardQuantity: 0,
                    fldDiscountPercentage: 0,
                    InwardNO: []
                },
                selectedDespatchDCDetails: {},
                editDespatchQtyList: []
            };
        default:
            return state;
    }
};
